module.exports = __webpack_public_path__ + "img/product-infoImage.3c0aab85.png";